import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { KomodoCoreWrappersModule } from '@komodo-design-system/komodo-core-angular-twelve-wrappers/dist/komodo-core-wrappers';
import { KwaAngular18Module } from '@komodo-design-system/komodo-kwa-angular-18';

import { CdsTooltipComponent } from './cds-tooltip.component';

@NgModule({
  declarations: [CdsTooltipComponent],
  exports: [CdsTooltipComponent],
  imports: [CommonModule, OverlayModule, KwaAngular18Module, KomodoCoreWrappersModule],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CdsTooltipModule {}
